<template>
  <div class="wrapper-content w-100">
    <h1 v-if="isOnEditMode">Edición {{form.title}}</h1>
    <h1 v-if="!isOnEditMode">Nuevo {{form.title}}</h1>
    <LmForm ref="lmFormRef">
      <div class="row">
        <LmTextInput class="col-12"
        v-model="form.title"
        label="Título"
        :v="$v.form.title" />
      </div>
      <div class="row">
         <div class="col-12">
           <b-form-group label="Destino" v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        id="radio-group-1"
        v-model="form.destination"
        :options="optionsDestination"
        :aria-describedby="ariaDescribedby"
        name="radio-options"
      ></b-form-radio-group>
    </b-form-group>
        </div>
      </div>

      <template v-if="form.destination === 'web'">
        <LmSelect v-model="selectedTagOrFilter" :options="optionsSelectTagOrFilter" />
        </template>

      <div class="row" v-if="form.destination === 'app' || (form.destination === 'web' && selectedTagOrFilter === 'tag') || form.destination === 'ambas' ">
        <LmTextInput class="col-12"
        v-model="form.tag"
        label="Tag"
        :v="$v.form.tag" />
      </div>

      <div class="row" v-if="form.destination === 'web' && selectedTagOrFilter === 'filter' ">
         <LmSuperPowerSelectV2
         class="col-12"
        v-model="form.filter"
        urlPathFromGetOptions="filtros/todos/"
        label="Filters"
      />
      </div>

      <div v-if="form.destination === 'app' ||  form.destination === 'web' || form.destination === 'ambas' ">
      <LmImagenPages v-model="options" v-show="options.image" @fileRemoved="fileRemoved" class="my-2 mb-4" />

         <LmUploadFiles
            label="Imagen Mobile"
            ref="lmUploadFiles"
            class="mb-3"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            :v="$v.form.image"
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
            v-show="!options.image"
        />
        </div>

        <div v-if="form.destination === 'web' || form.destination === 'ambas' ">
      <LmImagenPages v-model="optionsweb" v-show="optionsweb.image" @fileRemoved="fileRemovedWeb" class="my-2 mb-4" />

         <LmUploadFiles
            label="Imagen Web"
            ref="lmUploadFilesWeb"
            class="mb-3"
            :dropzoneOptions="dropzoneOptionsWeb"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            :v="$v.form.imageweb"
            @vdropzone-removed-file="fileRemovedWeb"
            @vdropzone-success="fileCreatedWeb"
            v-show="!optionsweb.image"
        />
        </div>

<b-form-group label="Activar Landing" class="mb-5">
      <b-form-checkbox v-model="form.active" size="lg" name="activo" switch>
      <span v-if="form.active">Activo</span>
      <span v-if="!form.active">Desactivo</span>
    </b-form-checkbox>
 </b-form-group>

   <LmButton
        id="btn-cancel"
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="formIsProcessing"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />

        <LmButton
            type="submit"
            buttonClass="btn-success"
            :isProcessing="formIsProcessing"
            :value="$t('Save')"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            @click.native="submit('guardar')"
        />

        <LmButton
            type="submit"
            buttonClass="btn-primary"
            :isProcessing="formIsProcessing"
            :value="$t('Guardar y salir')"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            @click.native="submit('guardarSalir')"
        />

    </LmForm>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'
import store from '@/store'

import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmButton from '@/components/form/elements/LmButton.vue'
import LmImagenPages from '@/views/365/pages/elements/LmImagenPages'
import LmSelect from '@/components/form/elements/LmSelect'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'

export default {
  components: {
    LmForm,
    LmTextInput,
    LmUploadFiles,
    LmButton,
    LmImagenPages,
    LmSelect,
    LmSuperPowerSelectV2
  },
  data () {
    return {
      form: {
        title: '',
        image: null,
        imageweb: null,
        tag: '',
        filter: null,
        destination: 'app',
        state: null,
        active: true
      },
      initialForm: {},
      files: [],
      filesWeb: [],
      formIsProcessing: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      },
      dropzoneOptionsWeb: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      },
      optionsDestination: [
        { text: 'APP', value: 'app' },
        { text: 'WEB', value: 'web' },
        { text: 'AMBAS', value: 'ambas' }
      ],
      selectedTagOrFilter: null,
      optionsSelectTagOrFilter: {
        content: [{ value: null, text: 'Por favor seleccione una opción' }, { value: 'tag', text: 'Tag' }, { value: 'filter', text: 'Filter' }]
      },
      options: {
        type: Object,
        idRandom: '',
        id: '',
        title: '',
        image: '',
        imageOriginalName: '',
        imageSize: '',
        default: () => ({
          disabledOption: 'Seleccione una acción',
          content: []
        })
      },
      optionsweb: {
        type: Object,
        idRandom: '',
        id: '',
        title: '',
        image: '',
        imageOriginalName: '',
        imageSize: '',
        default: () => ({
          disabledOption: 'Seleccione una acción',
          content: []
        })
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async submit (guardarType) {
      try {
        await this.$refs.lmFormRef.validationForm(this.$v)
        this.formIsProcessing = true
        const fileLoaded = this.files.length ? this.files[0].path : ''
        const fileLoadedWeb = this.filesWeb.length ? this.filesWeb[0].path : ''
        const dataToSendToTheServer = {
          title: this.form.title,
          tag: this.form.tag,
          active: this.form.active,
          filter: this.form.filter,
          destination: this.form.destination,
          id: this.form.id,
          image: this.form.image || fileLoaded,
          imageweb: this.form.imageweb || fileLoadedWeb
        }

        let apiUrl = this.isOnEditMode ? `${process.env.VUE_APP_API_URL}landing/edit-landing-pages/` : `${process.env.VUE_APP_API_URL}landing/new/`
        await axios.post(
          apiUrl,
          dataToSendToTheServer,
          {
            headers: {
              Authorization: `Bearer ${store.state.session.accessToken}`
            }
          }
        )

        if (guardarType === 'guardarSalir') {
          this.$router.push('/landing/listado')
        } else {
          this.makeToast('guardar')
          if (!this.isOnEditMode) {
            this.$nextTick(function () {
              this.form.title = null
              this.form.tag = null
              this.selectedTagOrFilter = null
              this.$refs.lmUploadFiles.lmRemoveAllFiles()
              this.$refs.lmUploadFilesWeb.lmRemoveAllFiles()
              this.$v.$reset()
            })
          }
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.formIsProcessing = false
      }
    },
    makeToast (variant = null) {
      if (variant === 'guardar') {
        this.$bvToast.toast('El contenido se guardó exitosamente.', {
          title: `Mensaje`,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    async setForm () {
      if (this.isOnEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: 'landing/read-landing-pages',
          id: this.$route.params.id,
          paramsMode: true
        })
          .then(() => {
            if (this.form.image) {
              const fileOption = {
                size: 100000
              }
              this.$refs.lmUploadFiles.lmManuallyAddFile(fileOption, this.form.apiUrlPath + this.form.image)
              this.options.image = this.form.image
            }

            if (this.form.imageweb) {
              const fileOption = {
                size: 100000
              }
              this.$refs.lmUploadFiles.lmManuallyAddFile(fileOption, this.form.apiUrlPath + this.form.imageweb)
              this.optionsweb.image = this.form.imageweb
            }
            if (this.form.tag) this.selectedTagOrFilter = 'tag'
            if (this.form.filter) this.selectedTagOrFilter = 'filter'
          })
          .catch(error => {
            console.log(error)
            this.$router.replace({ name: '404' })
          })
      } else {
        this.form = JSON.parse(this.initialForm)
        this.$refs.lmFormRef.showLoading()
        this.$refs.lmUploadFiles.lmRemoveAllFiles()
        if (this.$refs.lmUploadFilesWeb) this.$refs.lmUploadFilesWeb.lmRemoveAllFiles()
        this.form.image = ''
        this.options.image = ''
        this.optionsweb.image = ''
        this.form.imageweb = ''
        setTimeout(() => {
          this.$v.$reset()
          this.$refs.lmFormRef.hideLoading()
        }, 350)
      }
    },
    fileCreated (file, response) {
      if (response) {
        setTimeout(() => {
          this.options.idRandom = Math.random()
        }, 1000
        )
        // this.form.title = response.path
        this.form.image = response.path
        this.options.image = response.path
        this.options.tag = response.tag
        this.options.imageSize = this.bytesToSize(response.size)
        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileCreatedWeb (file, response) {
      if (response) {
        setTimeout(() => {
          this.optionsweb.idRandom = Math.random()
        }, 1000
        )
        // this.form.title = response.path
        this.form.imageweb = response.path
        this.optionsweb.image = response.path
        this.optionsweb.tag = response.tag
        this.optionsweb.imageSize = this.bytesToSize(response.size)
        this.filesWeb.push(response)
      }
      this.$refs.lmUploadFilesWeb.disable()
    },
    fileRemoved (file, error, xhr) {
      this.form.image = ''
      this.options.image = ''
      this.files = []
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.lmRemoveAllFiles()
      this.$refs.lmUploadFiles.enable()
    },
    fileRemovedWeb (file, error, xhr) {
      this.form.imageweb = ''
      this.optionsweb.image = ''
      this.filesWeb = []
      if (file) {
        this.filesWeb = this.filesWeb.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFilesWeb.lmRemoveAllFiles()
      this.$refs.lmUploadFilesWeb.enable()
    },
    cancelBtn () {
      this.$router.push('/landing/listado')
    },
    bytesToSize (bytes) {
      const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    }
  },
  validations: {
    form: {
      title: {
        required
      },
      image: {
        required
      }
    }
  },
  watch: {
    isOnEditMode () {
      this.setForm()
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  },
  mounted () {
    this.setForm()
  }
}
</script>

<style>

</style>
